
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { SingleFormInputDefinition } from '@/types';
import BaseFormInput from './BaseFormInput';

@Component({})
export default class TextFormInput extends BaseFormInput {}
